import Link from 'next/link';
import { useEffect, useState } from 'react';
import styles from './index.module.less';
import { Button, Dropdown, MenuProps, Popover } from 'antd';
import { useTranslation } from 'next-i18next';
import { useUserProvider } from '@/context/UserProvider';
import { useConfigProvider } from '@/context/ConfigProvider';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { useRouter } from 'next/router';
import Image from 'next/image';
import { fetchHairstyleRecordsBalanceData } from '@/lib/service';
import HairShareAlertContent from '@/components/Common/HairShareAlert';

const UserContent = () => {
  const {
    isLogin,
    shareUnreadCount,
    creditsCount,
    onCreditsChanged,
    onOpenLoginModal,
    onChangedLoginView,
    onSignOut,
    isFirstCreation,
    isFirstShare
  } = useUserProvider();
  const [firstLetter, setFirstLetter] = useState<string>('');
  const { t } = useTranslation();
  const router = useRouter();
  const [showPopover, setShowPopover] = useState(true);
  const [openShare, setOpenShare] = useState(false);
  const { isMobile } = useConfigProvider();
  const [showFirstCreationPopover, setShowFirstCreationPopover] = useState(true);
  const [showFirstSharePopover, setShowFirstSharePopover] = useState(true);
  const items: MenuProps['items'] = [
    {
      key: 'settings',
      label: <Link href={'/settings'}>{t('Settings')}</Link>
    },
    {
      key: 'my-credits',
      label: <Link href={'/my-credits'}>{t('My Credits')}</Link>
    },
    {
      key: 'billing-records',
      label: <Link href={'/billing-records'}>{t('PaymentHistory')}</Link>
    },
    {
      key: 'logout',
      label: (
        <Link href={'/'} onClick={() => onSignOut()}>
          {t('LogOut')}
        </Link>
      )
    }
  ];

  const loadBanaceList = () => {
    fetchHairstyleRecordsBalanceData().then((res) => {
      if (res?.code === 0) {
        onCreditsChanged(res?.data?.balance);
      }
    });
  };
  useEffect(() => {
    if (isLogin) {
      loadBanaceList();
    }
  }, [isLogin]);

  useEffect(() => {
    if (isFirstShare) {
      loadBanaceList();
    }
  }, [isFirstShare]);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(getAuth(), (user) => {
      if (user) {
        if (user?.email?.length > 0) {
          const tempLetter = user?.email[0];
          setFirstLetter(tempLetter.toLocaleUpperCase());
        } else {
          setFirstLetter('');
        }
      } else {
        setFirstLetter(undefined);
      }
    });

    return () => {
      if (isLogin) {
        unsubscribe();
      } else {
        setFirstLetter(undefined);
      }
    };
  }, [isLogin]);
  return (
    <div className={styles.content}>
      {firstLetter != undefined && isLogin ? (
        <div className={styles.loginDiv}>
          <div className={styles.creditDiv}>
            <Image src={'/images/hairstyle/credit_icon.png'} alt={''} width={30} height={30} />
            {isFirstCreation && showFirstCreationPopover && (
              <Popover
                placement="bottom"
                open={showFirstCreationPopover}
                color="#333333"
                title={
                  <div style={{ position: 'relative' }}>
                    <span style={{ color: '#ffffff', fontSize: '14px' }}>Get More Free Tries 🎁</span>
                    <Button
                      type="text"
                      size="small"
                      style={{
                        position: 'absolute',
                        right: '-8px',
                        top: '-8px',
                        color: '#ffffff',
                        fontSize: '12px'
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowFirstCreationPopover(false);
                      }}
                    >
                      ✕
                    </Button>
                  </div>
                }
                content={
                  <Button
                    type="text"
                    size="large"
                    style={{ color: '#ffffff', fontSize: '12px', backgroundColor: '#A26EFD' }}
                    onClick={() => setOpenShare(true)}
                  >
                    <span>
                      Share & Get
                      <br />
                      Free Tries!
                    </span>
                    <span style={{ marginLeft: '20px', display: 'flex', alignItems: 'center' }}>
                      +10
                      <Image src={'/images/hairstyle/credit_icon.png'} alt={''} width={20} height={20} />
                    </span>
                    <span style={{ marginLeft: '20px' }}>Share now</span>
                  </Button>
                }
              >
                <span className={styles.creditLabel}>{`Credit: `}</span>
              </Popover>
            )}
            {isFirstShare && showFirstSharePopover && (
              <Popover
                placement="bottom"
                open={showFirstSharePopover}
                color="#333333"
                content={
                  <div style={{ position: 'relative' }}>
                    <span style={{ color: '#ffffff', fontSize: '13px' }}>
                      ✅ Shared successfully!
                      <br />
                      🎁 You&apos;ve received 10 style credits — time to play again!
                    </span>
                    <Button
                      type="text"
                      size="small"
                      style={{
                        position: 'absolute',
                        right: '-8px',
                        top: '-8px',
                        color: '#ffffff',
                        fontSize: '12px'
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowFirstSharePopover(false);
                      }}
                    >
                      ✕
                    </Button>
                  </div>
                }
              >
                <span className={styles.creditLabel}>{`Credit: `}</span>
              </Popover>
            )}
            {!isFirstCreation && !isFirstShare && <span className={styles.creditLabel}>{`Credit: `}</span>}
            <span className={styles.creditCount}>{`${creditsCount}`}</span>
          </div>
          <Dropdown menu={{ items }} placement="bottomRight" autoAdjustOverflow={false}>
            <Button
              className={styles.emailIcon}
              onClick={() => {
                router.push('/dashboard');
              }}
            >
              {firstLetter}
              {shareUnreadCount > 0 && <p />}
            </Button>
          </Dropdown>
          <HairShareAlertContent
            openType={openShare}
            isGenerate={false}
            yourImage={null}
            dataList={[]}
            handleCancel={() => setOpenShare(false)}
            shareWeb={true}
          />
        </div>
      ) : (
        <Popover
          content={
            <div style={{ color: '#ffffff', display: 'flex', alignItems: 'center', gap: '4px', position: 'relative' }}>
              <div style={{ marginRight: '20px' }}>
                🎉Join now to get free hairstyle credits
                <br />- your first look&apos;s on us!
              </div>
              <Button
                type="text"
                size="small"
                style={{
                  position: 'absolute',
                  right: '-8px',
                  top: '-8px',
                  color: '#ffffff',
                  fontSize: '12px'
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  setShowPopover(false);
                }}
              >
                ✕
              </Button>
            </div>
          }
          placement="bottom"
          color="#333333"
          open={!isLogin && showPopover && !isMobile}
          styles={{
            body: {
              padding: '12px 16px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '14px',
              lineHeight: '20px',
              whiteSpace: 'nowrap'
            }
          }}
        >
          <Button
            className={styles.login}
            onClick={() => {
              onOpenLoginModal(true);
              onChangedLoginView(true);
            }}
          >
            {t('Sign In/Sign Up')}
          </Button>
        </Popover>
      )}
    </div>
  );
};

export default UserContent;
